export const MAX_SERIES_VISITS = 104
export const MAX_EVERY = 999
export const MAX_DURATION = 999
export const MAX_NAME = 150
export const MAX_SEARCH = 100
export const MAX_NOTE = 2000
export const SERIES_LIST_PER_PAGE = 20

export const SERIES_TEXT = {
  requestFailed: 'OpenEMR did not answer correctly. Try again later.',
  emrUnavailableBook:
    'OpenEMR did not answer. Nothing was retried — check the calendar before trying again.',
  emrUnavailableEdit: 'OpenEMR did not answer. Reload to see what was saved.',
} as const
